(function() {
    'use strict';

    var selectOnFocus = function() {
        return function(scope:any, element:any) {
                element.bind('focus', function() {
                this.select();
            });
        };
    };

    angular.module('onvio.documents').directive('selectOnFocus', selectOnFocus);
}());
